import { useNavigate } from 'react-router-dom';
import { User } from '@/types';
import { UserListComponent } from './UserList.component';

interface UserListProps {
  users: User[];
  loading?: boolean;
}

export const UserList: React.FC<UserListProps> = ({ users, loading }) => {
  const navigate = useNavigate();

  const handleUserClick = (username: string) => {
    navigate(`/user/${username}`);
  };

  return (
    <UserListComponent
      users={users}
      loading={loading}
      onUserClick={handleUserClick}
    />
  );
};

